import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import your components (We will create these files next)
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Sponsorship from './pages/Sponsorship';
import Contact from './pages/Contact';
import ProjectMini from './components/ProjectMini';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        {/* The Navbar stays at the top of every page */}
        <Navbar />
        {/* Project Mini Banner */}
        <ProjectMini />
        {/* The Main content changes based on the URL */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/sponsorship" element={<Sponsorship />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>

        {/* The Footer stays at the bottom of every page */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;